import { createContext, useContext } from 'react';

export interface AiTokenConsumptionContextProps {
  content: any;
  dateToSearch: Date;
  setDateToSearch: (date: Date) => void;
  periodOptions: any;
  currentMonth: boolean;
  tenant: any;
  loggedUser: any;
  trackingProps: any;
  getPlanStatus: () => Promise<any>;
}

const AiTokenConsumptionContext = createContext<AiTokenConsumptionContextProps>(
  {} as AiTokenConsumptionContextProps,
);

export function useAiTokenConsumptionContext(): AiTokenConsumptionContextProps {
  const context = useContext(AiTokenConsumptionContext);

  if (!context) {
    throw new Error(
      'useAiTokenConsumptionContext must be used within an AiTokenConsumptionContext.Provider',
    );
  }

  return context;
}

export default AiTokenConsumptionContext;
